import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { UserService } from './user.service';
import { Router } from '@angular/router';
import { InviteAccept, InviteResponse } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class SettingsService extends BaseApiService {
  constructor(
    http: HttpClient,
    router: Router,
    private userService: UserService
  ) {
    super(http, router);
  }

  retrieveUserId(hash: string): Observable<InviteAccept> {
    this.logout(false);

    const resource = 'teams/invitations/accept';
    const endpoint = `${this.baseUrl}/${resource}/${hash}`;

    return this.http.get<InviteAccept>(endpoint);
  }

  acceptInvitation(email: string, hash: string, password: string): Observable<HttpResponse<InviteResponse>> {
    const resource = 'teams/invitations/accept';
    const endpoint = `${this.baseUrl}/${resource}/${hash}/`;
    const body = {
      email,
      password
    };

    return this.http.post<InviteResponse>(endpoint, body, { observe: 'response' });
  }

  changePassword(
    payload: {
      current_password: string,
      new_password: string,
      confirm_new_password: string,
    }): Observable<void> {
    const resource = 'users/update-password/';
    const endpoint = `${this.baseUrl}/${resource}`;
    const body = {
      ...payload
    };

    return this.http.post<void>(endpoint, body);
  }

  logout(routeToLogin: boolean = true): void {
    this.userService.clearAuthData();
    localStorage.removeItem('basemap');

    if (routeToLogin === true) {
      this.router.navigate(['/login']);
    }
  }
}
